import { createInstance } from "i18next";
import es from "./locales/es.json";

// The local-SEO pages (cities, services) are written in Mexican Spanish only.
// They render with this separate, Spanish-only instance so their header and
// footer match the page — without the language detector, so visiting them
// never overwrites the visitor's saved language for the home page.
export const fixedEsI18n = createInstance({
  lng: "es",
  fallbackLng: "es",
  resources: { es: { translation: es } },
  interpolation: { escapeValue: false },
  initImmediate: false,
  react: { useSuspense: false },
});
fixedEsI18n.init();
